import { render } from "./aCardWave.vue?vue&type=template&id=6132d65a"
import script from "./aCardWave.vue?vue&type=script&lang=js"
export * from "./aCardWave.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__